import { childInitialStateType } from './Interface';
import { childActionType, ChildrenType } from './Types';

const initialState: childInitialStateType = {
	isLoading: false,
	error: '',
};

export const childrenReducer = (state = initialState, action: childActionType) => {
	switch (action.type) {
		case ChildrenType.LOAD_ALL_KIDS:
			return {
				...state,
				children: action.payload.data,
				error: undefined,
			};
		case ChildrenType.ADD_KID:
			return {
				...state,
				add: action.payload.message,
				addedKid: action.payload,
				error: undefined,
			};
		case ChildrenType.LOADING_KIDS_FAIL:
			return {
				...state,
				error: action?.payload?.errors,
			};
		case ChildrenType.REMOVE_KID:
			return {
				...state,
				error: undefined,
			};
		case ChildrenType.UPDATE_KIDS:
			return {
				...state,
			};

		case ChildrenType.LOOKUP_KID:
			// eslint-disable-next-line no-console
			console.log(action.payload, 'alaa');
			return {
				...state,
				error: undefined,
				lookupKid: action?.payload?.data,
				// allToyInstances: undefined,
			};
		case ChildrenType.TOY_INSTANCES:
			return {
				...state,
				allToyInstances: action.payload.data,
			};
		case ChildrenType.SHIP_TOY:
			return {
				...state,
				error: undefined,
			};
		case ChildrenType.NEXT_BOX: {
			return {
				...state,
				error: undefined,
				lookupKid: undefined,
				allToyInstances: undefined,
			};
		}
		case ChildrenType.CHANGE_EXPIRY_DATE:
			return {
				...state,
			};
		case ChildrenType.LOAD_ADDRESS_KID:
			return {
				...state,
				address: action.payload.data,
			};
		default:
			return state;
	}
};
